import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  StyledCompanies,
  StyledContainer,
  StyledMore,
  StyledSection
} from './HPCCompanies.styled';

type ContentProps = {
  content?: any[];
};

const HPCCompanies: React.FC<ContentProps> = ({ content }) => {
  const { t } = useI18n('hiring-process-comparison');

  return (
    <StyledSection id="companies">
      <StyledContainer>
        <Heading2 editorial>
          {t('hiring-process-comparison.available_companies.title')}
        </Heading2>
        <StyledCompanies>
          {content
            ?.sort(
              (a, b) =>
                a.attributes.relevantCompanyPosition -
                b.attributes.relevantCompanyPosition
            )
            .map(
              ({ id, attributes }) =>
                attributes.relevantCompanyPosition > 0 && (
                  <img
                    key={id}
                    src={attributes.logoRelevant.data.attributes.url}
                    alt={attributes.companyName}
                  />
                )
            )}
        </StyledCompanies>
        <StyledMore>
          <span>{t('hiring-process-comparison.available_companies.more')}</span>
        </StyledMore>
        <ButtonLink
          href="https://form.typeform.com/to/OoHs7m3N?source=WebCTA"
          target="_blank"
        >
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{t('hiring-process-comparison.available_companies.cta')}</span>
        </ButtonLink>
      </StyledContainer>
    </StyledSection>
  );
};

export default HPCCompanies;
